var getNative = require('./_getNative');

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;



//////////////////
// WEBPACK FOOTER
// ./~/victory-stack/~/lodash/_nativeCreate.js
// module id = ./node_modules/victory-stack/node_modules/lodash/_nativeCreate.js
// module chunks = 1